<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre4">
<p class="basic-paragraph"><span class="char-style-override">Lovesick Gods</span></p>
<p class="basic-paragraph1"><span class="char-style-override1">Lovesick Series - Part 1</span><span class="char-style-override2"></span></p>
<p class="basic-paragraph2"><span class="char-style-override2">Copyright </span><span class="char-style-override2">© 2017 - Amanda Meuwissen</span></p>
<p class="basic-paragraph1"><span class="char-style-override2">All rights reserved.</span></p>
<p class="basic-paragraph3">No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other noncommercial uses permitted by copyright law.</p>
<p class="basic-paragraph3">Editor - Kaila Corrington</p>
<p class="basic-paragraph3">Cover design - Veronika Dolnikova Ivanovna</p>
<p class="basic-paragraph3">Book layout - Mario Hernandez</p>
<p class="basic-paragraph3">Author Photo - Kyle Olson</p>
<p class="basic-paragraph2"><span class="char-style-override2">ISBN-13: 978-1-943619-35-1</span></p>
<p class="basic-paragraph1"><span class="char-style-override2">ISBN-10: 1-943619-35-2</span></p>
<p class="basic-paragraph2"><span class="char-style-override2">First U. S. Edition: September 2017</span></p>
<p class="basic-paragraph4"><span class="c">Printed in the United States of America</span><span class="c"></span></p>
<p class="basic-paragraph5"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LovesickGods_eBook1_01.vue?3239788d